import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "api-changelog"
    }}>{`API Changelog`}</h1>
    <p>{`This page details SDK API changes between the Experience Platform SDKs and 4x SDKs.`}</p>
    <h2 {...{
      "id": "mobile-core-apis"
    }}>{`Mobile Core APIs`}</h2>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/mobile-core/api-reference/"
      }}>{`Mobile Core API reference`}</a>{`.`}</p>
    <h3 {...{
      "id": "supported-apis"
    }}>{`Supported APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`extensionVersion`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`version/getVersion`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getPrivacyStatus`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`privacyStatus`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setPrivacyStatus`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`setPrivacyStatus:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setLogLevel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`setDebugLogging:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`configureWithFileInPath:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`overrideConfigPath:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`configureWithAppId#:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not applicable`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`updateConfiguration:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not applicable`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setAppGroup:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`setAppGroup:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackState:data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`trackState:data:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackAction:data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`trackAction:data:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`collectPII:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`collectPII:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getSdkIdentities:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`getAllIdentifiersAsync:`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "deprecated-apis-and-functionality"
    }}>{`Deprecated APIs and functionality`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackActionFromBackground`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackLocation:data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackBeacon:Data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Support modified. See `}<a parentName="td" {...{
              "href": "https://developer.adobe.com/client-sdks/documentation/adobe-analytics/track-beacon/"
            }}>{`guide`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingClearCurrentBeacon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`registerAdobeDataCallback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`lifetimeValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackLifetimeValueIncrease:data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionStart:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionUpdate:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionEnd:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionExists:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackPushMessageClickThrough:userInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Support modified. See `}<a parentName="td" {...{
              "href": "https://developer.adobe.com/client-sdks/documentation/faq/#how-can-i-track-user-engagement-of-push-notifications-using-the-experience-platform-mobile-sdk"
            }}>{`guide`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tracking App Crash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "lifecycle-extension-apis"
    }}>{`Lifecycle extension APIs`}</h2>
    <h3 {...{
      "id": "supported-apis-1"
    }}>{`Supported APIs`}</h3>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`In the v4 iOS SDK, Lifecycle start and stop calls are made automatically by the SDK. In the AEP SDK, the calls to start and stop lifecycle will need to be made by the application developer. For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/mobile-core/lifecycle/ios/"
      }}>{`Lifecycle extension in iOS`}</a>{`.`}</p>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/mobile-core/lifecycle/api-reference/"
      }}>{`Lifecycle API reference`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`lifecycleStart:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`collectLifecycleData`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`lifecycleStart:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`collectLifecycleWithAdditionalData`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`lifecyclePause`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pauseCollectingLifecycleData (Android only)`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "deprecated-apis"
    }}>{`Deprecated APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`keepLifecycleSessionAlive`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "identity-extension-apis"
    }}>{`Identity extension APIs`}</h2>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/mobile-core/identity/api-reference/"
      }}>{`Identity API reference`}</a>{`.`}</p>
    <h3 {...{
      "id": "supported-apis-2"
    }}>{`Supported APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setPushIdentifier:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`setPushIdentifier`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setAdvertisingIdentifier:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`setAdvertisingIdentifier`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getExperienceCloudId:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorMarketingCloudID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`syncIdentifiers:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorSyncIdentifiers`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`syncIdentifiers:authentication:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorSyncIdentifiers:authenticationState:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`syncIdentifier:identifier:authentication:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorSyncIdentifiersWithType:identifier:authenticationState:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getIdentifiers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorGetIDs`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`appendToURL:withCallback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorAppendToURL:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getUrlVariables`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`visitorGetUrlVariablesAsync:`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "adobe-analytics-extension-apis"
    }}>{`Adobe Analytics extension APIs`}</h2>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/adobe-analytics/api-reference/"
      }}>{`Analytics API reference`}</a>{`.`}</p>
    <h3 {...{
      "id": "supported-apis-3"
    }}>{`Supported APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getVisitorIdentifier:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`getUserIdentifier`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setVisitorIdentifier:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`setUserIdentifier`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getTrackingIdentifier:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingIdentifier`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sendQueuedHits:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingSendQueuedHits`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`clearQueue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingClearQueue`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getQueueSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingGetQueueSize`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "adobe-audience-manager-extension-apis"
    }}>{`Adobe Audience Manager extension APIs`}</h2>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/adobe-audience-manager/api-reference/"
      }}>{`Audience Manager Extension API Reference`}</a>{`.`}</p>
    <h3 {...{
      "id": "supported-apis-4"
    }}>{`Supported APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`extensionVersion`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not applicable`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getVisitorProfile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`audienceVisitorProfile`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`​signalWithData:callback:​`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`audienceSignalWithData:callback`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`​`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`reset`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "deprecated-apis-1"
    }}>{`Deprecated APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`audienceSetDpid:dpuuid:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Replaced - See `}<a parentName="td" {...{
              "href": "%E2%80%8Bhttps://experienceleague.adobe.com/docs/audience-manager/user-guide/reference/cid.html?lang=en"
            }}>{`Link`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`audienceDpid:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Replaced - See `}<a parentName="td" {...{
              "href": "https://experienceleague.adobe.com/docs/audience-manager/user-guide/reference/cid.html?lang=en"
            }}>{`Link`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`audienceDpuuid:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Replaced - See `}<a parentName="td" {...{
              "href": "https://experienceleague.adobe.com/docs/audience-manager/user-guide/reference/cid.html?lang=en"
            }}>{`Link`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "adobe-target-extension-apis"
    }}>{`Adobe Target extension APIs`}</h2>
    <p>{`For more information see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/adobe-target/api-reference/"
      }}>{`Target API reference`}</a>{`.`}</p>
    <h3 {...{
      "id": "supported-apis-5"
    }}>{`Supported APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK (iOS / Android)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getThirdPartyId:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetThirdPartyID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setThirdPartyId:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetSetThirdPartyID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getTntid:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not applicable`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`resetExperience:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetClearCookies`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`prefetchObjectWithName:mboxParameters:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetPrefetchObjectWithName:mboxParameters:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`prefetchContent:withProfileParameters:callback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetPrefetchContent:withProfileParameters:callback:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`prefetchClearCache:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetPrefetchClearCache`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`requestObjectWithName:defaultContent:mboxParameters:callback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetRequestObjectWithName:defaultContent:mboxParameters:callback:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`loadRequests:withProfileParameters:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`targetLoadRequests:withProfileParameters:`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "deprecated-apis-2"
    }}>{`Deprecated APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetPcID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetSessionID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetLoadRequest:callback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetLoadRequestWithName:defaultContent:profileParameters:orderParameters:mboxParameters:callback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetLoadRequestWithName:defaultContent:profileParameters:orderParameters:mboxParameters:requestLocationParameters:callback:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetCreateRequestWithName:defaultContent:parameters:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetCreateOrderConfirmRequestWithName:orderId:orderTotal:productPurchasedId:parameters:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      